import { ComplexValue } from 'app/types-shared';
import { BowtieCase, BowtieCaseModel, BowtieLayout, CaseRegistrationTemplate } from './types';
import { ConnectedCase } from './types-store';

export const ACTION = {
  CLEAR_BOWTIE_DATA: 'BOWTIE:CLEAR_BOWTIE_DATA',
  REQUEST_BOWTIE: 'BOWTIE:REQUEST_BOWTIE',
  RECEIVE_BOWTIE: 'BOWTIE:RECEIVE_BOWTIE',
  FAIL_BOWTIE: 'BOWTIE:FAIL_BOWTIE',
  REQUEST_DRAFT: 'BOWTIE:REQUEST_DRAFT',
  RECEIVE_DRAFT: 'BOWTIE:RECEIVE_DRAFT',
  FAIL_DRAFT: 'BOWTIE:FAIL_DRAFT',
  REQUEST_CASE: 'BOWTIE:REQUEST_CASE',
  RECEIVE_CASE: 'BOWTIE:RECEIVE_CASE',
  FAIL_CASE: 'BOWTIE:FAIL_CASE',
  REQUEST_CONNECTED_CASES: 'BOWTIE:REQUEST_CONNECTED_CASES',
  RECEIVE_CONNECTED_CASES: 'BOWTIE:RECEIVE_CONNECTED_CASES',
  FAIL_CONNECTED_CASES: 'BOWTIE:FAIL_CONNECTED_CASES',
  CLEAN_DATA: 'BOWTIE:CLEAN_DATA',
  REQUEST_CONNECT_DRAFT: 'BOWTIE:REQUEST_CONNECT_DRAFT',
  RECEIVE_CONNECT_DRAFT: 'BOWTIE:RECEIVE_CONNECT_DRAFT',
  FAIL_CONNECT_DRAFT: 'BOWTIE:FAIL_CONNECT_DRAFT',
  REQUEST_BOWTIE_FAVOURITE: 'BOWTIE:REQUEST_BOWTIE_FAVOURITE',
  RECEIVE_BOWTIE_FAVOURITE: 'BOWTIE:RECEIVE_BOWTIE_FAVOURITE',
  INCREMENT_REQUEST_ID: 'BOWTIE:INCREMENT_REQUEST_ID',
  REQUEST_CONNECTED_CASES_BY_CONNECTION_TYPE: 'BOWTIE:REQUEST_CONNECTED_CASES_BY_CONNECTION_TYPE',
  RECEIVE_CONNECTED_CASES_BY_CONNECTION_TYPE: 'BOWTIE:RECEIVE_CONNECTED_CASES_BY_CONNECTION_TYPE',
  UPDATE_BOWTIE: 'BOWTIE:UPDATE_BOWTIE',
  REQUEST_CHANGE_CONNECTION_SEQUENCE: 'BOWTIE:REQUEST_CHANGE_CONNECTION_SEQUENCE',
  RECEIVE_CHANGE_CONNECTION_SEQUENCE: 'BOWTIE:RECEIVE_CHANGE_CONNECTION_SEQUENCE',
  FAIL_CHANGE_CONNECTION_SEQUENCE: 'BOWTIE:FAIL_CHANGE_CONNECTION_SEQUENCE',
  REQUEST_VALIDATE_CASE_ID: 'BOWTIE:REQUEST_VALIDATE_CASE_ID',
  RECEIVE_VALIDATE_CASE_ID: 'BOWTIE:RECEIVE_VALIDATE_CASE_ID',
  FAIL_VALIDATE_CASE_ID: 'BOWTIE:FAIL_VALIDATE_CASE_ID'
};

export class ClearBowtieData {
  public type: string = ACTION.CLEAR_BOWTIE_DATA;
  constructor(public instanceKey: string) {}
}

export class RequestBowtie {
  public type: string = ACTION.REQUEST_BOWTIE;
  constructor(public caseNumber: number, public draftId: number, public instanceKey: string) {
  }
}

export class ReceiveBowtie {
  public type: string = ACTION.RECEIVE_BOWTIE;
  constructor(public caseNumber: number,
    public draftId: number,
    public caseDataModel: BowtieCaseModel,
    public bowtieLayout: BowtieLayout,
    public caseTemplate: CaseRegistrationTemplate,
    public evaluations: { [caseNumber: number]: ComplexValue<number>[] },
    public instanceKey: string) {
  }
}

export class FailBowtie {
  public type: string = ACTION.FAIL_BOWTIE;
  constructor(public caseNumber: number, public draftId: number, public instanceKey: string) {
  }
}

export class RequestDraft {
  public type: string = ACTION.REQUEST_DRAFT;
  constructor(public requestId: number, public instanceKey: string) {
  }
}

export class ReceiveDraft {
  public type: string = ACTION.RECEIVE_DRAFT;
  constructor(public requestId: number, public draftData: BowtieCase, public connectionTypes: ComplexValue<number>[], 
     public draftEtag: string, public instanceKey: string) {
  }
}

export class FailDraft {
  public type: string = ACTION.FAIL_DRAFT;
  constructor(public requestId: number, public instanceKey: string) {
  }
}

export class RequestCase {
  public type: string = ACTION.REQUEST_CASE;
  constructor(public caseNumber: number, public instanceKey: string) {
  }
}

export class ReceiveCase {
  public type: string = ACTION.RECEIVE_CASE;
  constructor(public caseNumber: number, public evaluation: ComplexValue<number>[], public instanceKey: string) {
  }
}

export class FailCase {
  public type: string = ACTION.FAIL_CASE;
  constructor(public caseNumber: number, public instanceKey: string) {
  }
}

export class RequestConnectedCases {
  public type: string = ACTION.REQUEST_CONNECTED_CASES;
  constructor(public caseNumber: number, public connectionType: number, public instanceKey: string) {
  }
}

export class ReceiveConnectedCases {
  public type: string = ACTION.RECEIVE_CONNECTED_CASES;
  constructor(public caseNumber: number, public connectionType: number, public connected: ConnectedCase[], public instanceKey: string) {
  }
}

export class FailConnectedCases {
  public type: string = ACTION.FAIL_CONNECTED_CASES;
  constructor(public caseNumber: number, public connectionType: number, public instanceKey: string) {
  }
}

export class CleanData {
  public type: string = ACTION.CLEAN_DATA;
  constructor(public instanceKey: string) {}
}

export class RequestConnectDraft {
  public type: string = ACTION.REQUEST_CONNECT_DRAFT;
  constructor(public caseNumber: number,  public instanceKey: string) {
  }
}

export class ReceiveConnectDraft {
  public type: string = ACTION.RECEIVE_CONNECT_DRAFT;
  constructor(public caseNumber: number, public instanceKey: string) {
  }
}

export class FailConnectDraft {
  public type: string = ACTION.FAIL_CONNECT_DRAFT;
  constructor(public caseNumber: number, public instanceKey: string) {
  }
}

export class RequestBowtieFavourite {
  public type: string = ACTION.REQUEST_BOWTIE_FAVOURITE;
  constructor(public instanceKey: string) {}
}

export class ReceiveBowtieFavourite {
  public type: string = ACTION.RECEIVE_BOWTIE_FAVOURITE;
  constructor(public bowtieFavouriteId: number, public instanceKey: string) { }
}

export class IncrementRequestId {
  public type: string = ACTION.INCREMENT_REQUEST_ID;
  constructor(public instanceKey: string) {}
}

export class RequestConnectedCasesByConnectionType {
  public type: string = ACTION.REQUEST_CONNECTED_CASES_BY_CONNECTION_TYPE;
  constructor(public caseNumber: number, public connectionType: number[], public instanceKey: string) {
  }
}

export class ReceiveConnectedCasesByConnectionType {
  public type: string = ACTION.RECEIVE_CONNECTED_CASES_BY_CONNECTION_TYPE;
  constructor(public caseNumber: number,
    public connectedCases: Record<number, number[]>,
    public instanceKey: string) {
  }
}

export class UpdateBowtie {
  public type: string = ACTION.UPDATE_BOWTIE;
  constructor(public caseNumber: number,
    public caseDataModel: BowtieCaseModel,
    public caseTemplate: CaseRegistrationTemplate,
    public connectedCases: Record<number, ConnectedCase[]>,
    public instanceKey: string) {
  }
}

export class RequestChangeConnectionSequence {
  public type: string = ACTION.REQUEST_CHANGE_CONNECTION_SEQUENCE;
  constructor(public caseNumber: number,
    public parentCaseId: number,
    public instanceKey: string) {
  }
}

export class ReceiveChangeConnectionSequence {
  public type: string = ACTION.RECEIVE_CHANGE_CONNECTION_SEQUENCE;
  constructor(public caseNumber: number,
    public parentCaseId: number,
    public instanceKey: string) {
  }
}

export class FailChangeConnectionSequence {
  public type: string = ACTION.FAIL_CHANGE_CONNECTION_SEQUENCE;
  constructor(public caseNumber: number,
    public parentCaseId: number,
    public instanceKey: string) {
  }
}

export class RequestValidateCaseId {
  public type: string = ACTION.REQUEST_VALIDATE_CASE_ID;
  constructor(public instanceKey: string, public caseNumber: number) {
  }
}

export class ReceiveValidateCaseId {
  public type: string = ACTION.RECEIVE_VALIDATE_CASE_ID;
  constructor(public instanceKey: string, public caseNumber: number, public entityId: number) {
  }
}

export class FailValidateCaseId {
  public type: string = ACTION.FAIL_VALIDATE_CASE_ID;
  constructor(public instanceKey: string, public caseNumber: number) {
  }
}
